<template>
  <v-list class="lang" ref="langMenu" v-observe-visibility="visible=>hideLangs(visible)" >
    <v-list-group :value="espActive" v-bind:key="'esp'" >
      <v-list-tile slot="activator" @click.stop.prevent="espActive=!espActive" no-action>
        <v-list-tile-content style="width: 100px">
        <v-list-tile-title>Español</v-list-tile-title>
          </v-list-tile-content>
        <v-list-tile-action>
          <v-icon @click.stop.prevent="espActive=!espActive" >{{espActive ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</v-icon>
        </v-list-tile-action>
      </v-list-tile>
      <v-list-tile v-for="item in esp" :key="item.code" @click="locale(item.code)">
        <v-list-tile-avatar size="20"><img :src=item.icon :alt="item.code+'-flag'"></v-list-tile-avatar>
        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
      </v-list-tile>
    </v-list-group>

    <v-list-tile @click="locale('eu-ES')">
      <v-list-tile-content>
        <v-list-tile-title>Euskara</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-group :value="catActive" v-bind:key="'cat'" >
      <v-list-tile slot="activator" @click.stop.prevent="catActive=!catActive" no-action>
        <v-list-tile-content style="width: 100px">
          <v-list-tile-title>Català</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-icon @click.stop.prevent="catActive=!catActive" >{{catActive ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</v-icon>
        </v-list-tile-action>
      </v-list-tile>
      <v-list-tile v-for="item in cat" :key="item.code" @click="locale(item.code)">
        <v-list-tile-avatar size="20"><img :src=item.icon :alt="item.code+'-flag'"></v-list-tile-avatar>
        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
      </v-list-tile>
    </v-list-group>

    <v-list-tile @click="locale('en-US')">
      <v-list-tile-content>
        <v-list-tile-title>English</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile @click="locale('it-IT')">
      <v-list-tile-content>
        <v-list-tile-title>Italiano</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile @click="locale('fr-FR')">
      <v-list-tile-content>
        <v-list-tile-title>Français</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>


<script>
  import Api from '~/store/idonia-api/api'
  import {useBusUtils} from '~/commons/busUtils'
  import bus from '~/bus'
  import i18n from '~/i18n'

const { BusHandlerManager } = useBusUtils()
  export default {
    name: 'platform-actions',
    computed: {
      isAuthenticated: function () {
        return this.$store.getters['session/isAuthenticated']
      },
      accountID () {
        return this.$store.state.session.accountId
      },
      langMenu: function () {
        return this.$refs.langMenu
      }
    },
    data () {
      return {
        espActive: false,
        catActive: false,
        bhm: new BusHandlerManager(),
        esp: [
          { title: 'Argentina', code: 'es-AR', icon: '/static/flags/1x1/ar.svg' },
          { title: 'Chile', code: 'es-CL', icon: '/static/flags/1x1/cl.svg' },
          { title: 'Colombia', code: 'es-CO', icon: '/static/flags/1x1/co.svg' },
          { title: 'España', code: 'es-ES', icon: '/static/flags/1x1/es.svg' },
          { title: 'México', code: 'es-MX', icon: '/static/flags/1x1/mx.svg' }],
        cat: [
          { title: 'Andorra', code: 'ca-AD', icon: '/static/flags/1x1/ad.svg' },
          { title: 'Espanya', code: 'ca-ES', icon: '/static/flags/1x1/es.svg' }]
      }
    },
    watch: {
      catActive (val) {
        if (val) {
          this.espActive = false
        }
      },
      espActive (val) {
        if (val) {
          this.catActive = false
        }
      }
    },
    methods: {
      hideLangs (visible) {
        if (!visible) {
          this.espActive = false
          this.catActive = false
        }
      },
      locale (locale) {
        this.espActive = false
        this.$store.dispatch('session/locale', locale)
        this.$i18n.locale = locale
        this.$moment.locale(locale.slice(0, 2))
        if (this.isAuthenticated) {
          Api.putV2('account/' + this.accountID, {data: {preferred_lang: locale}})
            .then(() => {
              this.$store.dispatch('session/loadAccountData')
              bus.$emit('reloadAccountInfo')
              bus.$emit('analytics', {
                action: 'change-language',
                arguments: {
                  lang: locale
                }
              })
            })
        }
      }
    },
    mounted () {
      this.bhm.addHandler(bus, 'updateLocale', (locale) => {
        if (this) {
          this.$i18n ? this.$i18n.locale = locale : i18n.locale = locale
          if (this.$moment) this.$moment.locale(locale.slice(0, 2))
        }
      })
    },
    deleted () {
      this.bhm.cleanAll()
    }
  }
</script>
<style lang="scss" scoped>
  .list__tile__avatar {
    margin-right: 15px;
  }
  .list__tile__sub-title {
    max-width: 350px;
    text-overflow: ellipsis;
  }
</style>
<style>
  .lang .list__group__header__append-icon{
    display: none;
  }
  .menu__content{
    margin-top: 25px;
    width: fit-content;
  }
</style>



// WEBPACK FOOTER //
// src/components/header/lang/FullLangMenu.vue